var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"position-fixed w-100 bg-white",staticStyle:{"z-index":"100"}},[_c('HeaderUserInfo'),_c('HeaderNav')],1),_c('HeaderUserInfo'),_c('HeaderNav'),_c('router-view'),_c('FooterUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }